export default __webpack_public_path__ + "static/lucrys_dashboard-6646f56660716addba2d82a08cab17ec.png";